import useWalletCurrency from '~/client/hooks/currency/useWalletCurrency';
import useSite from '~/client/hooks/useSite';
import {
  useMenuItemsQuery,
  MenuItemsQueryVariables,
} from '../../../GameList/graphql/MenuItemsQuery.generated';

const SECTION_MAP: Partial<Record<FilterSection, number>> = {
  categories: 0,
  providers: 1,
};

const getMenuItem = (name?: string) => {
  switch (name) {
    case 'live-casino':
      return 'live-dealer';
    default:
      return name;
  }
};

const useFilterDropdown = (
  type: FilterSection,
  rules?: string,
  menuItem?: string,
  theme?: string,
) => {
  const { site } = useSite();
  const currency = useWalletCurrency();
  const variables: MenuItemsQueryVariables = {
    filter: {
      site,
      currency,
      section: SECTION_MAP[type],
      gameLeaderboardSettings: rules,
    },
    sort: { order: 1 },
    menuItemGamesFilter: { currency, menuItem: getMenuItem(menuItem), theme },
  };
  const { data, loading } = useMenuItemsQuery({
    variables,
  });

  const options: FilterOption[] =
    data?.casino?.menuItems?.edges
      ?.map(({ node }) => {
        if (!node?.name || !node?.handle) {
          return { label: '', value: '', count: 0 };
        }
        return {
          label: node?.name,
          value: node?.handle,
          count: node.games?.totalCount ?? 0,
        };
      })
      ?.filter((option) => option?.count) ?? [];

  return { options, loading };
};

export default useFilterDropdown;
